import { TYPES } from '../../common/constants';
export const setSearch = payload => ({
    type: TYPES.SET_SEARCH,
    payload,
  });
  
  export const clearSearch = () => ({
      type:TYPES.CLEAR_SEARCH,
  })